export const REDEN_VAN_STATUS_IN_AANMAAK = "1";
export const REDEN_VAN_STATUS_INACTIEF = "2";
export const REDEN_VAN_STATUS_INGEDIEND = "121450000";
export const MAN = "121450000";

export const HAS_CONCURRENCY_EXCEPTION = "HAS_CONCURRENCY_EXCEPTION";
export const HAS_VALIDATION_ERRORS_SAVED = "HAS_VALIDATION_ERRORS_SAVED";
export const HAS_VALIDATION_ERRORS = "HAS_VALIDATION_ERRORS";
export const HAS_FILE_EXCEPTION = "HAS_FILE_EXCEPTION";
export const SUCCESS = "SUCCESS";
export const PDF_GENEREREN = "PDF_GENEREREN";
export const PDF_SIMULATIE_GENEREREN = "PDF_SIMULATIE_GENEREREN";

export const DomainScopes = {
    DEFAULT: "default",
    FEDERATIE: "federatie",
    SPORTORGANISATIE: "sportOrganisatie",
    NIEUWESPORTCLUB: "nieuweSportclub",
    LOGIN: "login",
    GEMEENTE: "gemeente"
};

export const UserTypes = { //only used in frontend to show/hide things for different user in shared scope
    DEFAULT: "default",
    FEDERATIEMEDEWERKER: "federatieMedewerker",
    WEBSITEBEZOEKER: "websiteBezoeker",
    GEMEENTEMEDEWERKER: "gemeenteMedewerker"
};

export const AccountTypes = {
    ORGANISATOR: "121450000",
    KOEPELORGANISATIE: "121450001",
    GEMEENTE: "121450002",
    FEDERATIE: "121450003",
};

export const RechtspersoonlijkheidTypes = {
    VZW: 121450000,
    FEITELIJKE_VERENIGING: 121450001,
    ANDERE: 121450002
};

export const Landen = {
    BELGIE: "ce5ff1db-f747-4ce5-9fc4-f5ec9151e89c"
};

export const LandCodes = {
    BELGIE: "BE"
};

export const CustomNavActions = {
    DIEN_IN: "DIEN_IN"
};

export const Environments = {
    LOCAL: "LOCAL",
    SDEV: "SDEV",
    PPD: "PPD",
    PRD: "PRD"
};

export const TransactionDomainEnum = {
    UNKNOWN: 0,
    SPORTORGANISATIE: 1
};

export const AdresTypes = {
    MAATSCHAPPELIJKE_ZETEL: 1,
    CORRESPONDENTIEADRES: 2,
    EXPLOITATIEADRES: 3,
};

export const RelatieTypesEnum = {
	ERKEND_DOOR: "1",
	HIERARCHISCH_AFHANKELIJK_VAN: "2",
	LID_VAN: "3",
    GESUBSIDIEERD_DOOR: "4"
};

export const RelatieTypes = [
    {
        value: "1",
        label: "Erkend door"
    },
    {
        value: "2",
        label: "Afhankelijk van"
    },
    {
        value: "3",
        label: "Lid van"
    },
    {
        value: "4",
        label: "Gesubsidieerd door"
    }
];

export const BezoekerTabs = {
    ORGANISATIEGEGEVENS: { title: "Organisatiegegevens", url: "/nieuweSportclub/organisatie", tab: "organisatie" },
    IDENTIFICATIEGEGEVENS: { title: "Identificatiegegevens", url: "/nieuweSportclub/identificatie", tab: "identificatie" },
    ADRESSEN: { title: "Adressen", url: "/nieuweSportclub/adres", tab: "adres" },
    SPORTTAKKEN: { title: "Sporttakken", url: "/nieuweSportclub/sporttak", tab: "sporttak" },
    DOELGROEPEN: { title: "Doelgroepen", url: "/nieuweSportclub/doelgroep", tab: "doelgroep" },
    SOCIALE_MEDIA: { title: "Sociale media", url: "/nieuweSportclub/socialemedia", tab: "socialeMedia" },
    ANDERE_OPMERKINGEN: { title: "Andere opmerkingen", url: "/nieuweSportclub/andereOpmerkingen", tab: "andereOpmerking" }
};

export const BezoekerLabels = {
    naam: "Naam",
    afkorting: "Afkorting",
    telefoon: "Telefoon",
    gsm: "GSM",
    email: 'E-mailadres',
    website: "Website",
    extraGegevens: "Extra gegevens",
    logo: "Logo",
    documentatie: "Documentatie",
    oprichtDatum: "Datum oprichting",
    ondernemingsnummer: "Ondernemingsnummer",
    rechtsvorm: "Rechtsvorm",
    isAangeslotenBijSportfederatie: "Aangesloten bij federatie?",
    naamSportfederatie: "Naam sportfederatie",
    sporttakken: "Sporten",
    doelgroepen: "Doelgroepen",
    facebookLink: "Facebook",
    linkedInLink: "LinkedIn",
    youTubeLink: "YouTube",
    instagramLink: "Instagram",
    opmerking: "Opmerking"
};

export const NiveauInstanties = {
    INTERNATIONAAL: 1,
    EUROPEES: 2,
    NATIONAAL: 3,
    GEWEST_GEMEENSCHAP: 4,
    PROVENCIAAL: 5,
    GEMEENTELIJK: 6,
    DISTRICT: 7
};

export const OrganisatieTypes = {
    SPORTRAAD: "Sportraad"
};